import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import type { Subject } from '@chancenwerk/db/courses/CourseDigital.js';
import { Course } from './Course.js';

/**
 * @entity CourseIntensiveSingle
 *
 * Intensivkurse Einzeltermine für die CHANCENreise
 */
@Entity()
export class CourseIntensiveSingle extends Course {
  public static override _class = 'CourseIntensiveSingle';

  @Field(type => String)
  public subject: Maybe<Subject>;
}
